import i18n from 'services/base/i18n';

export default {
  // Network Speed: Gigabits per second
  gbps: () => i18n.pgettext('Components|Bandwidth Settings', 'Gbps'),
  // Network Speed: Megabits per second
  mbps: () => i18n.pgettext('Components|Bandwidth Settings', 'Mbps'),
  // Network Speed: Kilobits per second
  kbps: () => i18n.pgettext('Components|Bandwidth Settings', 'Kbps'),
  // Network Speed: bits per second
  bps: () => i18n.pgettext('Components|Bandwidth Settings', 'bps'),
};
